import { useState, memo } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Radio from '@zenbusiness/zui/Radio';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { ANNUAL_REVENUES } from './constants/annuaRevenues';

const AnnualRevenueUIField = ({
  field = { setSaved: () => {}, setLoading: () => {} },
  value = '',
  dataChangeHandler = () => {},
  disabled
}) => {
  const [annualRevenue, setAnnualRevenue] = useState(value || '');
  const trackRevenueChangeClick = useClickstreamCallback('buttonPressed');

  const handleRevenueChange = (event, selectedValue) => {
    if (selectedValue) {
      field.setLoading();
    }

    // Tracking Details: Tracking added to expected annual business income.
    trackRevenueChangeClick({
      elementText: event?.target?.name || selectedValue, // Pass the button or radio name
      elementName: 'banking_collect_info',
      appPageName: 'banking_application'
    });

    setAnnualRevenue(selectedValue);
    dataChangeHandler(
      selectedValue,
      { annualRevenue: selectedValue },
      (forceUpdate, { isSave, isError }) => {
        field.setSaved(isSave, isError);
        forceUpdate();
      }
    );
  };

  const revenueList = ANNUAL_REVENUES.map(({ label, key }) => (
    <FormControlLabel
      control={<Radio aria-label="revenue option" />}
      key={label}
      label={<Text size="xl">{label}</Text>}
      name={label}
      sx={{
        width: 'max-content'
      }}
      value={key}
    />
  ));

  return (
    <Stack spacing="16px">
      <FormControl disabled={disabled}>
        <RadioGroup
          name="annual revenue"
          onChange={handleRevenueChange}
          sx={{ gap: '16px' }}
          value={annualRevenue}
        >
          {revenueList}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};

AnnualRevenueUIField.propTypes = {
  value: PropTypes.string,
  dataChangeHandler: PropTypes.func,
  field: PropTypes.shape({
    setSaved: PropTypes.func,
    setLoading: PropTypes.func
  }),
  disabled: PropTypes.bool
};

function areEqual(preProp, nextProp) {
  return (
    preProp.field === nextProp.field &&
    preProp.value === nextProp.value &&
    preProp.disabled === nextProp.disabled
  );
}

export default memo(AnnualRevenueUIField, areEqual);
